import React, { useState } from "react";
import PropTypes from "prop-types";
import inputsData from "./data/newQuoteInputsDatas";
import { InputsProvider } from "./contexts/InputsContext";
import RadioButtonStep from "./steps/RadioButtonStep";
import TextStep from "./steps/TextStep";
import { findInputs } from "./concerns/findInputs";
import NextButton from "./steps/NextButton";
import NewQuoteFooter from "./steps/NewQuoteFooter";
import DatePickerStep from "./steps/DatePickerStep";
import NewQuoteNavbar from "./steps/NewQuoteNavbar";
import NewQuoteLoadingPage from "./steps/NewQuoteLoadingPage";

const NewQuoteForm = (data) => {
  const csrfToken = data.token;

  const [loading, setLoading] = useState(false);

  const [inputs, setInputs] = useState(inputsData);
  const value = { inputs, setInputs };

  const lastIndex = inputs.steps.length - 1;
  const currentIndex = inputs.currentIndex;
  const lastStepInput = findInputs(inputs, lastIndex);

  const handleSubmit = () => {
    setLoading(true);
  };

  return (
    <InputsProvider value={value}>
      <div className={`h-full ${loading ? "block" : "hidden"}`}>
        <NewQuoteLoadingPage />
      </div>
      <div className={`h-full ${loading ? "hidden" : "block"}`}>
        <form
          action="/quotes"
          method="post"
          className="h-full flex flex-col justify-between"
        >
          <div>
            <NewQuoteNavbar />
            <div className="container mx-auto px-6 md:max-w-screen-xl my-10 flex items-center justify-center">
              <div>
                <input
                  type="hidden"
                  name="authenticity_token"
                  value={csrfToken}
                />
                <RadioButtonStep stepIndex={0} />
                <RadioButtonStep stepIndex={1} />
                <RadioButtonStep stepIndex={2} />
                <RadioButtonStep stepIndex={3} />
                <DatePickerStep stepIndex={4} />
                <TextStep stepIndex={5} />
                <RadioButtonStep stepIndex={6} />
                <TextStep stepIndex={7} />
              </div>
            </div>
            <div className="container mx-auto px-6 md:max-w-screen-xl my-10 flex items-center justify-center">
              <NextButton lastStepInput={lastStepInput} />
              <input
                type="submit"
                value="Envoyer"
                onClick={() => handleSubmit()}
                className={`px-8 py-6 w-60 flex items-center justify-center bg-orange-500 text-white text-2xl font-bold rounded-lg cursor-pointer ${
                  lastIndex === currentIndex && lastStepInput.valid
                    ? "block"
                    : "hidden"
                }`}
              />
            </div>
          </div>
          <div>
            <NewQuoteFooter />
          </div>
        </form>
      </div>
    </InputsProvider>
  );
};

NewQuoteForm.propTypes = {
  labtokenel: PropTypes.string,
};

export default NewQuoteForm;
